module.exports = __webpack_public_path__ + "assets/e8acfeb20d5a395f486eed022381472d.png";